import { render } from "./CommuteRecommendations.vue?vue&type=template&id=93838a8a"
import script from "./CommuteRecommendations.vue?vue&type=script&lang=js"
export * from "./CommuteRecommendations.vue?vue&type=script&lang=js"

import "./CommuteRecommendations.vue?vue&type=style&index=0&id=93838a8a&lang=css"

import exportComponent from "/codebuild/output/src1559117955/src/employer_portal_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__